<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <form class="modal-content">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Add New Contact</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <div v-if="step=='details'">
                            <div class="mb-4">
                                <label for="contact-name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="contact-name" name="contact-name" placeholder="Contact Name" v-model="contact_name">
                            </div>
                            <div class="mb-4">
                                <label for="contact-customer" class="form-label">Company</label>
                                <select class="form-select" id="contact-name" name="contact-customer" placeholder="Contact Name" v-model="contact_customer">
                                    <option v-for="dataRow in this.modalData.customers" :value="dataRow.id">{{dataRow.name}}</option>
                                </select>
                            </div>
                            <div class="mb-4">
                                <label class="form-label" for="contact-position">Position</label>
                                <input type="text" class="form-control" id="contact-position" name="contact-position" placeholder="Contact Position" v-model="contact_position">
                            </div>
                            <div class="mb-4">
                                <label class="form-label" for="contact-email">Email</label>
                                <input type="text" class="form-control" id="contact-email" name="contact-email" placeholder="Contact Email" v-model="contact_email">
                            </div>
                            <div class="mb-4">
                                <label for="contact-phone-number" class="form-label">Phone Number</label>
                                <input type="text" class="form-control" id="contact-phone-number" name="contact-phone-number" placeholder="Phone Number" v-model="contact_number">
                            </div>
                        </div>
                        <div v-else>
                            <div class="mb-4">
                                <label for="contact-address-line-1" class="form-label">Address Line 1</label>
                                <input type="text" class="form-control" id="contact-address-line-1" name="contact-address-line-1" placeholder="Address Line 1" v-model="contact_address_line_1">
                            </div>
                            <div class="mb-4">
                                <label for="contact-address-line-2" class="form-label">Address Line 2</label>
                                <input type="text" class="form-control" id="contact-address-line-2" name="contact-address-line-2" placeholder="Address Line 2" v-model="contact_address_line_2">
                            </div>
                            <div class="mb-4">
                                <label for="contact-address-line-3" class="form-label">Address Line 3</label>
                                <input type="text" class="form-control" id="contact-address-line-3" name="contact-address-line-3" placeholder="Address Line 3" v-model="contact_address_line_3">
                            </div>
                            <div class="mb-4">
                                <label for="contact-address-line-4" class="form-label">Address Line 4</label>
                                <input type="text" class="form-control" id="contact-address-line-4" name="contact-address-line-4" placeholder="Address Line 4" v-model="contact_address_line_4">
                            </div>
                            <div class="mb-4">
                                <label for="contact-postcode" class="form-label">Postcode</label>
                                <input type="text" class="form-control" id="contact-postcode" name="contact-postcode" placeholder="Postcode" v-model="contact_postcode">
                            </div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button v-if="step == 'details'" type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Cancel</button>
                        <button v-if="step == 'address'" type="button" class="btn btn-sm btn-alt-secondary me-1" v-on:click="step = 'details'">Go Back</button>
                        <button type="button" class="btn btn-sm btn-primary" v-on:click="submit">{{step == 'details' ? 'Continue' : 'Submit'}}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal'
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        saveModalRoute: {
            type: String
        },
        modalData: {
            type: Object,
            default() {
                return {}
            },
        },
        selectName: {
            type: String
        }
    },
    data() {
        return {
            contact_name: '',
            contact_position: '',
            contact_number: '',
            contact_email: '',
            contact_customer: '',
            contact_address_line_1: '',
            contact_address_line_2: '',
            contact_address_line_3: '',
            contact_address_line_4: '',
            contact_postcode: '',
            step: 'details'
        };
    },
    mounted () {
        this.modal = new Modal(this.$el);
        Eventbus.on('add-new' + this.selectName, () => {
            this.modal.show();
        });

        this.$el.addEventListener('hide.bs.modal', () => {
            this.step = 'details';
            window.jQuery("form").trigger('reset');
            window.jQuery("input").value = '';
        });

        this.$el.addEventListener('show.bs.modal', () => {// need both to make sure fields are cleared on submit for some reason
            this.step = 'details';
            window.jQuery("form").trigger('reset');
            window.jQuery("input").value = '';
        });

    },
    methods: {
        async submit () {
            if (this.step == 'details') {
                this.step = 'address';
            } else if (this.step == 'address') {
                await axios.post(this.saveModalRoute, {
                    contact_name: this.contact_name,
                    contact_position: this.contact_position,
                    contact_number: this.contact_number,
                    contact_email: this.contact_email,
                    contact_customer: this.contact_customer,
                    contact_address_line_1: this.contact_address_line_1,
                    contact_address_line_2: this.contact_address_line_2,
                    contact_address_line_3: this.contact_address_line_3,
                    contact_address_line_4: this.contact_address_line_4,
                    contact_postcode: this.contact_postcode,
                }).then((response) => {
                    Eventbus.emit('newSelect' + this.selectName, [this.contact_name, response.data.data]);
                    this.modal.hide();
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not save contact',
                        text: 'System error. We were unable to save your contact',
                    });
                });
            }
        }
    }
}
</script>
